import React from "react";
import LogIn from "../../components/Login/login";
import { Routes, Route } from "react-router-dom";
import Forgot from "../../components/Login/forgot";
import Reset from "../../components/Login/reset";
import Register from "../../components/Login/register";
import Terms from "../../components/Login/terms";
import Privacy from "../../components/Login/privacy";
import PageNotFound from "../Errors/PageNotFound";
import Copyright from "../../components/Commons/Shared/Copyright";
import Logo from "../../components/Login/logo";
import "../../assets/css/zones.css";

const bg = require("../../assets/images/bg-login.jpeg");

export default function Login() {
  return (
    <div
      style={{
        backgroundImage: `url(${bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        minHeight: "100vh",
        display: "flex",
        padding: "20px",
        overflowY: "auto",
      }}
    >
      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "16px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
          width: "100%",
          maxWidth: "480px",
          padding: "30px 24px",
          margin: "auto",
          position: "relative",
        }}
      >
        <div style={{ marginBottom: 24, textAlign: "center" }}>
          <Logo />
        </div>

        <Routes>
          <Route path="/" element={<LogIn />} />
          <Route path="/login" element={<LogIn />} />
          <Route path="/register" element={<Register />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/forgot-password" element={<Forgot />} />
          <Route path="/reset-password" element={<Reset />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>

        <div style={{ marginTop: 24, textAlign: "center" }}>
          <Copyright />
        </div>
      </div>
    </div>
  );
}
